import { makeStyles } from '@mui/styles';

const style = makeStyles((theme: any) => ({
  profileBox: {
    display: 'grid',
    gridGap: 16,
    gridTemplateColumns: '56px 1fr',
  },
  learnerImg: {
    maxWidth: 56,
    width: 56,
    height: 56,
    marginRight: theme.spacing(3),
  },
  [theme.breakpoints.up('md')]: {
    profileBox: {
      alignItems: 'center',
      display: 'grid',
      gridTemplateColumns: '162px 1fr',
    },
    learnerImg: {
      maxWidth: 160,
      width: 160,
      height: 160,
    },
  },
}));

export default style;
